import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M16.77 4.88a3 3 0 0 0-4.24 0l-1.35 1.35a4.52 4.52 0 0 0-3.6-1.79C5.07 4.44 3.02 6.48 3.02 9v11h2V9c0-1.41 1.15-2.56 2.56-2.56.91 0 1.72.48 2.17 1.22L8.29 9.12a3 3 0 0 0 0 4.24l2.12 2.12 8.48-8.49-2.12-2.12zm-6.36 7.78-.71-.71a.996.996 0 0 1 0-1.41l4.24-4.24c.19-.19.45-.29.71-.29s.51.1.71.29l.71.71-5.66 5.66zm10.6-2.12-1.41 1.41-1.41-1.41.71-2.12 2.12 2.12zm-4.95.7 2.12 2.12-1.41 1.41-1.41-1.41.71-2.12zm-2.83 2.83 2.12 2.12-1.41 1.41-1.41-1.41.71-2.12z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }